<ideal-keywords-inline-view
  [keywords]="keywords() || []"
  [match]="match()"
  [matchType]="matchType()"
  [caseSensitiveMatch]="caseSensitiveMatch()"
></ideal-keywords-inline-view>
